import { XStack, XStackProps } from '@mythical/ui'
import SearchBar from './SearchBar'
import { useRouter } from 'solito/router'
import SearchFilters from './SearchFilters'

interface SearchProps extends XStackProps {
  id: string
  hideFilters?: boolean
}

const Search = ({ id, hideFilters, ...props }: SearchProps) => {
  const router = useRouter()

  const handleSubmit = () => {
    router.push('/search')
  }

  return (
    <XStack pos="relative" gap="$2" ai="center" w="100%" {...props}>
      <SearchBar onSubmit={handleSubmit} id={id} />
      {!hideFilters && <SearchFilters />}
    </XStack>
  )
}

export default Search
